import { makeStyles } from "@mui/styles";
import clsx from "clsx";
import React from "react";
import { NavLink } from "react-router-dom";
import MenuButton, { Props as MenuButtonProps } from "./MenuButton";
import MenuIconButton, { Props as MenuIconButtonProps } from "./MenuIconButton";

interface Props extends Omit<MenuButtonProps & MenuIconButtonProps, "label" | "icon"> {
    target: string;
    exact?: boolean;
    activeClassName?: string;
    buttonClassName?: string;
    label?: string;
    icon: React.ElementType | React.ReactNode;
}

const useStyles = makeStyles(() => ({
    navLink: {
        textDecoration: "none"
    },
    activeNavLink: {
        "&>button": {
            backgroundColor: "black",
            color: "white",
            "&:hover": {
                backgroundColor: "#333",
                color: "white"
            }
        }
    }
}));

const MenuNavButton: React.FC<Props> = props => {
    const classes = useStyles();
    const {
        className,
        buttonClassName,
        activeClassName,
        label,
        icon,
        ...buttonProps
    } = props;

    return (
        <NavLink
            to={props.target}
            className={linkProps => clsx(classes.navLink, className, linkProps.isActive && classes.activeNavLink, linkProps.isActive && activeClassName)}>

            {label === undefined && (
                <MenuIconButton
                    {...buttonProps}
                    label={label}
                    icon={icon}
                    className={buttonClassName} />
            )}

            {label !== undefined && (
                <MenuButton
                    {...buttonProps}
                    label={label}
                    icon={icon}
                    className={buttonClassName} />
            )}

        </NavLink>
    );
};

export default MenuNavButton;
